<template>
  <main class="home">
    <div class="hero" v-view>
      <div class="hero-bg">
      </div>
    </div>
  </main>
</template>

<script>

export default {
  name: 'home'
}
</script>

<style scoped>
.hero {
  height:100%;
  width:100%;
  margin:0 0 50px 0;
}
.hero .hero-bg {
  display:block;
  height:100%;
  min-height:50vh;
  width:100%;
  background-image:url('../assets/herobg.jpg');
  background-repeat:no-repeat;
  background-position:center;
  background-size: cover;
}
</style>
